import React from "react";
import styles from "./Brief.module.scss";
import Image from "next/image";

const Brief = () => {
  return (
    <div className={styles.Brief}>
      <div className={styles.conatiner}>
        <div className={styles.picthers}>
          <div className={styles.image}>
            <Image
              src='/assets/Image/exploreImage.png'
              alt='exploreImage'
              width={800}
              height={600}
              className={styles.img}
            />
          </div>
        </div>
        <div className={styles.content}>
          <div className={styles.wrapperTitle}>
            <h1 className={styles.title}>
              Explore the{' '}
              <span className={styles.spanTitle}>B-Love Network </span> Plan in
              detail
            </h1>
            <button className={styles.button}>
              <a
                href='/assets/blove-network-pdf.pdf'
                download='blove-network-pdf'
              >
                Download Pdf{' '}
              </a>
            </button>
          </div>
        </div>
      </div>
    </div>
  )
};

export default Brief;
